export const SET_SERVICE_REQUEST_ALL = 'SET_SERVICE_REQUEST_ALL'
export const SET_SERVICE_REQUEST_ALL_DETAIL = 'SET_SERVICE_REQUEST_ALL_DETAIL'

